import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Organisation from "./Organisation";
import type OrganisationTeam from "./OrganisationTeam";

@Model()
class MediaReleaseUnsubscribedRecipient extends ApplicationRecord {
  static jsonapiType = "media_release_unsubscribed_recipients";

  @Attr({ persist: false }) createdAt: string;

  @BelongsTo() organisation: Organisation;

  @BelongsTo() organisationTeam: OrganisationTeam;

  @Attr() recipient: string;

  @Attr({ persist: false }) updatedAt: string;
}

export default MediaReleaseUnsubscribedRecipient;
